<form *ngIf="rateTemplateFormGroup" [formGroup]="rateTemplateFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="name">Nombre</label>
            <input pInputText formControlName="name" d-form-field-error />
        </div>
    </div>
    <div class="flex justify-content-end mb-2" *ngIf="rateTemplate.id">
        <p-button *ngIf="allowWrite" label="Añadir línea de baremo" icon="pi pi-plus"
            (click)="editRateTemplateLine(null)" />
    </div>
    <p-table *ngIf="rateTemplate.id" #grid [value]="rateTemplateLines" [loading]="loadingRateTemplateLines"
        [paginator]="true" [rows]="5" [totalRecords]="totalRateTemplateLinesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th pSortableColumn="rateLine.code">Código <p-sortIcon field="rateLine.code"></p-sortIcon></th>
                <th pSortableColumn="rateLine.description">Descripición <p-sortIcon
                        field="rateLine.description"></p-sortIcon></th>
                <th pSortableColumn="description">Descripición adicional <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th pSortableColumn="quantity">Cantidad <p-sortIcon field="quantity"></p-sortIcon></th>
                <th pSortableColumn="rateLine.price">Precio <p-sortIcon field="rateLine.price"></p-sortIcon></th>
                <th>Total</th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rateTemplateLine let-columns="columns">
            <tr (dblclick)="editRateTemplateLine(rateTemplateLine.id)">
                <td>{{rateTemplateLine.rateLine.code}}</td>
                <td>{{rateTemplateLine.rateLine.description}}</td>
                <td>{{rateTemplateLine.description}}</td>
                <td>{{rateTemplateLine.quantity}}</td>
                <td>{{rateTemplateLine.rateLine.price}}</td>
                <td>{{rateTemplateLine.quantity * rateTemplateLine.rateLine.price}}</td>
                <td>
                    <div class="flex gap-2 justify-content-end">
                        <p-button *ngIf="allowWrite" (click)="editRateTemplateLine(rateTemplateLine.id)"
                            [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                        <p-button *ngIf="allowDelete" (click)="deleteRateTemplateLine(rateTemplateLine.id)"
                            [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
            (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
</form>